import { render } from "./ContextMenuSubmenu.vue?vue&type=template&id=589b6ec6&scoped=true"
import script from "./ContextMenuSubmenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenuSubmenu.vue?vue&type=script&lang=ts"

import "./ContextMenuSubmenu.vue?vue&type=style&index=0&id=589b6ec6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-589b6ec6"

export default script